import { DisplayCampaign } from './display';
import type { TAffinityCampaign } from './types';

export class AffinityCampaign extends DisplayCampaign<TAffinityCampaign> {}
